module.exports = __webpack_public_path__ + "static/styled-738dfe366506961aa40d30622c4a0edf.png";